import { OPEN_EDIT_SEQUENCE_MODAL } from 'crm-events-data';
// @ts-expect-error Could not find a declaration file
import SequenceActions from 'sequences-crm-lib/flux/SequenceActions';
import { useCallback, useMemo, useState } from 'react';
import SequenceEnrollmentEditModalAsync from 'sequences-crm-events-lib/components/modals/SequenceEnrollmentEditModalAsync';
import { fetchSequenceEnrollment } from 'crm-timeline-tasks/queues/data/SequencesAPI';
import { fromJS } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
export const useEditSequenceModalActionHandler = ({
  objectType,
  subjectId
}) => {
  const [enrollment, setEnrollment] = useState(null);
  const handleEditSequenceModalAction = useCallback((actionType, data) => {
    if (actionType === OPEN_EDIT_SEQUENCE_MODAL) {
      const {
        enrollmentId
      } = data;
      fetchSequenceEnrollment(enrollmentId).then(fetchedEnrollment => {
        setEnrollment(fetchedEnrollment);
      }).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
    }
    return;
  }, []);
  const handleCloseEditSequenceModal = useCallback(() => {
    setEnrollment(null);
  }, [setEnrollment]);
  const handleConfirmEditSequenceModal = useCallback(({
    result,
    error
  }) => {
    SequenceActions.updateEnrollmentAlert({
      enrollment: result,
      subjectId,
      objectType,
      error
    });
  }, [subjectId, objectType]);
  const editSequenceModal = useMemo(() => {
    if (!enrollment) {
      return null;
    }
    return /*#__PURE__*/_jsx(SequenceEnrollmentEditModalAsync, {
      enrollment: fromJS(enrollment),
      onConfirm: handleConfirmEditSequenceModal,
      onClose: handleCloseEditSequenceModal
    });
  }, [enrollment, handleConfirmEditSequenceModal, handleCloseEditSequenceModal]);
  return {
    handleEditSequenceModalAction,
    editSequenceModal
  };
};